import {
  List,
  Datagrid,
  NumberField,
  Edit,
  SimpleForm,
  NumberInput,
  Show,
  SimpleShowLayout,
} from 'react-admin'

// <List filters={postFilters}>
// const postFilters = [
//     <TextInput source='q' label='Search' alwaysOn />,
//     <ReferenceInput source='userId' label='User' reference='users' />,
// ]

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const ServiceConfigList = () => (
  <List>
    <Datagrid bulkActionButtons={false} rowClick="edit">
      <NumberField source="intervalInMinutes" />
      <NumberField source="tokensLimit" />
    </Datagrid>
  </List>
)

export const ServiceConfigEdit = () => (
  <Edit>
    <SimpleForm>
      <NumberInput source="intervalInMinutes" />
      <NumberInput source="tokensLimit" />
    </SimpleForm>
  </Edit>
)

export const ServiceConfigShow = () => (
  <Show>
    <SimpleShowLayout>
      <NumberField source="intervalInMinutes" />
      <NumberField source="tokensLimit" />
    </SimpleShowLayout>
  </Show>
)
